/**
 * @fileoverview Onboarding helpers (pure functions, no React)
 *
 * Used by:
 * - src/routes/_app/_auth/onboarding/_layout.organization.tsx
 * - src/routes/_app/_auth/onboarding/-ui.onboarding-invitation.tsx
 */

import { ConvexError } from "convex/values";

/**
 * Extracts the user-facing message from an error thrown by an onboarding
 * action. Backend `ConvexError`s carry a string written for the user (e.g.
 * "Your invitation to join X has expired…"); anything else — a network
 * failure, a validator error, a bare `Error` — falls back to the supplied
 * generic message so raw stack text never reaches the screen.
 */
export function getOnboardingErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (error instanceof ConvexError && typeof error.data === "string") {
    const message = error.data.trim();
    return message || fallback;
  }
  return fallback;
}
